<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel">
                        <h2>Cadastrar Tomada</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDeTomada" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Horário Tomada</mat-label>
                            <mat-select value="Horário" formControlName="horaTomada" name="horaTomada">
                                <mat-option *ngFor="let horaTomada of listaHorarios" [value]="horaTomada.codigo">
                                    {{ horaTomada.descricao }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioDeTomada.controls.horaTomada.hasError('required')">
                                O campo Horário Tomada é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioDeTomada.controls.horaTomada.hasError('invalid')">
                                O campo Horário Tomada está inválido.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioDeTomada.valid || !procedimentoAgenda">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="voltarPaginaAnterior()"
                                matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>